import React from 'react';

const STYLES = {
  red: {
    backgroundColor: '#fce8e6',
    color: '#c5221f',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
  amber: {
    backgroundColor: '#fef7e0',
    color: '#ea8600',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
  blue: {
    backgroundColor: '#e8f0fe',
    color: '#1967d2',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
  green: {
    backgroundColor: '#e6f4ea',
    color: '#137333',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '12px',
    fontWeight: 600,
  },
};

export function stockColor(stock) {
  if (stock == null) return STYLES.blue;
  if (stock <= 0) return STYLES.red;
  if (stock <= 5) return STYLES.amber;
  if (stock <= 20) return STYLES.blue;
  return STYLES.green;
}

export default function StockBadge({ stock }) {
  return <span style={stockColor(stock)}>{stock}</span>;
}
